import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "EXEMPTION_APPLICATION",
    applicationRights: Rights,
    title: 'Disp.s&oslash;knader',
    text: 'Disp.s&oslash;knader',
    icon: 'medal',
    url: "/exemption-applications",
    routes: Routes,
    sequenceNo: 17100
})
